<!--
 * @Author: your name
 * @Date: 2021-05-28 09:41:06
 * @LastEditTime: 2023-06-21 14:08:05
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: D:\shihuaItem\epec-ope\src\views\authorityManager\authority.vue
-->
<template>
  <div>
    <div class="container">
      <div class="handle-search">
        <e-search
          :data="filterInfo.data"
          :field-list="filterInfo.fieldList"
          :list-type-info="listTypeInfo"
          :width="filterInfo.width"
          @handleFilter="handleSearch"
          @handleReset="handleReset"
          @handleEvent="handleEvent"
        ></e-search>
      </div>
    </div>
    <div class="container">
      <div style="text-align: right; margin-right: 20px">
        <el-button type="text" @click="handleEnterUBM">进入企业UBM</el-button>
      </div>
      <section class="container-wrapper">
        <!--			<div class="container" style="padding: 0;border: none;width: 100%">-->
        <div class="content-left">
          <div class="content-title">
            <p>组织机构</p>
          </div>
          <!-- <div class="content-btn flex-right">
                        <el-button size="mini" type="primary" @click="showDialog">新增</el-button>
                    </div> -->

          <el-divider></el-divider>
          <div
            style="
              height: 90%;
              width: 100%;
              display: flex;
              flex-direction: column;
              overflow: auto;
            "
          >
            <el-tree
              v-if="showTree"
              ref="myAuthorityTree"
              :key="1"
              :data="authorityTreeData"
              :props="defaultProps"
              :default-expand-all="expandAll"
              :lazy="false"
              :expand-on-click-node="false"
              node-key="orgId"
              :filter-node-method="filterAuthTreeNode"
              draggable
              :allow-drag="allowDrag"
              :allow-drop="allowDrop"
              @node-click="handleNodeClick"
              @node-drop="handleNodeDrop"
            >
              <template slot-scope="{ node, data }">
                <div style="width: 100%">
                  <e-tooltip
                    :content="data.shortFullName"
                    class="tooltip-wrapper"
                    :set-length="8"
                  />
                  <!--                                <span>{{data.shortFullName}}</span>-->
                  <div style="float: right">
                    <el-tooltip
                      :open-delay="500"
                      :enterable="false"
                      content="新增"
                      placement="top"
                      effect="light"
                    >
                      <i
                        class="el-icon-plus"
                        style="margin-left: 5px"
                        @click="nodeAdd(node, data)"
                      ></i>
                    </el-tooltip>
                    <el-tooltip
                      :open-delay="500"
                      :enterable="false"
                      content="编辑"
                      placement="top"
                      effect="light"
                    >
                      <i
                        class="el-icon-edit"
                        style="margin-left: 5px"
                        @click="nodeEdit(node, data)"
                      ></i>
                    </el-tooltip>
                    <el-tooltip
                      :open-delay="500"
                      :enterable="false"
                      content="转移"
                      placement="top"
                      effect="light"
                    >
                      <i
                        class="el-icon-d-caret"
                        style="margin-left: 5px"
                        @click="nodeTransfer(node, data)"
                      ></i>
                    </el-tooltip>
                    <el-tooltip
                      :open-delay="500"
                      :enterable="false"
                      content="上移"
                      placement="top"
                      effect="light"
                    >
                      <el-link :disabled="checkDisabled(node, data, 'up')">
                        <i
                          class="el-icon-top"
                          @click="handleDrag(node, data, 'up')"
                        ></i>
                      </el-link>
                    </el-tooltip>
                    <el-tooltip
                      :open-delay="500"
                      :enterable="false"
                      content="下移"
                      placement="top"
                      effect="light"
                    >
                      <el-link :disabled="checkDisabled(node, data, 'down')">
                        <i
                          class="el-icon-bottom"
                          @click="handleDrag(node, data, 'down')"
                        ></i>
                      </el-link>
                    </el-tooltip>
                    <el-tooltip
                      :open-delay="500"
                      :enterable="false"
                      content="删除"
                      placement="top"
                      effect="light"
                    >
                      <i
                        class="el-icon-delete"
                        style="margin-left: 5px"
                        @click="nodeDelete(node, data)"
                      ></i>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-tree>
          </div>
        </div>
        <div class="content-right">
          <TableList
            :loading="loading"
            :table-data="tableData"
            :table-label="tableLabel"
          >
            <template #isUsed="slot">
              {{ formatStatus(slot.scope.row.isUsed) }}
            </template>
            <template #orgLevelId="slot">
              {{ formatEnterLevel(slot.scope.row.orglevelid) }}
            </template>
            <template #orgName="slot">
              <e-tooltip
                :content="slot.scope.row.orgName"
                class="tooltip-wrapper"
                set-length="14"
              />
            </template>
          </TableList>

          <div style="text-align: right; margin-bottom: 10px; margin-top: 10px">
            <el-pagination
              :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="productTagPage.currentPage"
              :page-size="productTagPage.pageSize"
              prev-text="上一页"
              next-text="下一页"
              :total="productTagPage.pageTotal"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>

        <!--			</div>-->
        <el-dialog
          :title="title"
          :visible.sync="dialogVisible"
          width="600px"
          :modal-append-to-body="false"
          @close="cancelCategory"
        >
          <div>
            <el-form
              ref="formData"
              :rules="rulesAuth"
              :model="formData"
              label-width="120px"
            >
              <!-- <el-form-item label="上级组织机构:">
                <span style="display:inline-block;" class="input-style">
                  {{ formData.lastGradeName }}
                </span>
              </el-form-item> -->
              <el-form-item label="组织机构名称:" prop="orgName">
                <el-input
                  v-model="formData.orgName"
                  class="input-style"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="ERS机构编码:" prop="ersorgCode">
                <el-input
                  class="input-style"
                  v-model="formData.ersorgCode"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构编码:" prop="orgCode">
                <el-input
                  class="input-style"
                  v-model="formData.orgCode"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构短名称:" prop="shortName">
                <el-input
                  class="input-style"
                  v-model="formData.shortName"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构简化全称:" prop="shortFullName">
                <el-input
                  class="input-style"
                  v-model="formData.shortFullName"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构层级:" prop="orglevelid">
                <el-select v-model="formData.orglevelid">
                  <el-option :value="101" label="企业"></el-option>
                  <el-option :value="102" label="单位"></el-option>
                  <el-option :value="103" label="部门"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="状态:">
                <el-radio v-model="formData.isUsed" :label="1">启用</el-radio>
                <el-radio v-model="formData.isUsed" :label="0">停用</el-radio>
              </el-form-item>

              <!-- <el-form-item label="扩展属性:">
                <el-input
                  class="input-style"
                  type="textarea"
                  v-model="formData.extendAttr"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="备注:">
                <el-input
                  v-model="formData.remark"
                  class="input-style"
                  type="textarea"
                  maxlength="255"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-left: 40%">
            <span slot="footer">
              <el-button @click="cancelCategory">取 消</el-button>
              <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </span>
          </div>
        </el-dialog>
      </section>
    </div>
    <el-dialog
      title="转移部门"
      :visible.sync="dialogVisibleTransfer"
      width="600px"
      :modal-append-to-body="false"
    >
      <el-form
        ref="transferFormData"
        :rules="rulesAuth"
        :model="transferFormData"
        label-width="180px"
      >
        <el-form-item label="部门名称:">
          <span style="display: inline-block" class="input-style">
            {{ transferFormData.orgName }}
          </span>
        </el-form-item>
        <el-form-item label="转移前上级组织机构名称:">
          <el-input
            v-model="transferFormData.lastParentOrgName"
            class="input-style"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="转移后上级组织机构:">
          <el-input
            v-model="transferFormData.nowTransferOrgName"
            class="input-style"
            @focus="selOrgTreeNode"
          ></el-input>
        </el-form-item>
        <div style="margin-left: 40%">
          <span slot="footer">
            <el-button @click="cancelTransfer">取 消</el-button>
            <el-button type="primary" @click="confirmTransfer">确 定</el-button>
          </span>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="组织机构"
      :visible.sync="dialogVisibleOrganion"
      width="500px"
      :modal-append-to-body="false"
    >
      <div>
        部门：
        <el-input
          v-model="searchVal"
          class="input-style"
          style="width: 60%"
        ></el-input>
        <el-button
          style="float: right"
          size="mini"
          type="primary"
          @click="searchOrgTree"
        >
          搜索
        </el-button>
      </div>
      <div
        style="
          height: 300px;
          overflow: auto;
          border: 1px solid #ccc;
          margin: 10px 0;
        "
      >
        <el-tree
          ref="selOrgTree"
          class="filter-tree"
          :data="selOrgTreeData"
          :props="defaultProps"
          :default-expand-all="expandAll"
          :highlight-current="true"
          :filter-node-method="filterNode"
          node-key="orgId"
        ></el-tree>
      </div>
      <div style="margin-left: 40%">
        <span slot="footer">
          <el-button @click="cancelSelOrgTree">取 消</el-button>
          <el-button type="primary" @click="confirmSelOrgTree">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/organization/index';
import eSearch from '../../components/common/e-search';
import TableList from '../../components/common/e-table-list';
import { ubmUrl } from '../../api/config';
import eTooltip from '../../components/common/e-tooltip';
import { checkRemark, checkKeyword } from '../../utils/validate';

export default {
  components: {
    eSearch,
    TableList,
    eTooltip,
  },
  data() {
    return {
      transferFormData: {
        orgName: '',
        orgId: '',
        lastParentOrgId: '',
        lastParentOrgName: '',
        nowTransferOrgId: '',
        nowTransferOrgName: '',
      },
      expandAll: true,
      searchVal: '',
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '机构ID',
          param: 'orgId',
          align: 'center',
          width: '80',
        },
        {
          label: '组织机构名称',
          param: 'orgName',
          align: 'center',
          slot: 'orgName',
        },
        // {
        //   label: '企业层级',
        //   param: 'orglevelid',
        //   align: 'center',
        //   slot: 'orgLevelId',
        //   width:'80'
        // },
        // {
        //   label: 'ERS编码',
        //   param: 'ersorgCode',
        //   align: 'center',
        // },
        // {
        //   label: '机构编码',
        //   param: 'orgCode',
        //   align: 'center',
        //   width:'80'
        // },
        {
          label: '状态',
          param: 'isUsed',
          align: 'center',
          slot: 'isUsed',
          width: '80',
        },
        // {
        //   label: '扩展属性',
        //   param: 'remark',
        //   align: 'center',
        // },
        {
          label: '备注',
          param: 'remark',
          align: 'center',
          tooltip: true,
        },
      ],
      filterInfo: {
        //   查询组件
        data: {
          // attributeName: null, // 规格属性编号
          // remark: null, // 第二名称
          pageSize: 10, // 每页多少条
          pageStart: 1,
          orgLevelId: '',
          isUsed: '',
          orgName: '',
        },
        // 查询
        fieldList: [
          //   { label: "规格属性名称：", type: "input", value: "attributeName" },

          //   { label: '计数', type: 'inputNumber', value: 'count', min: 1, max: 10 },
          {
            label: '组织机构名称',
            type: 'input',
            value: 'orgName',
          },
          // {
          //   label: '企业层级',
          //   type: 'radio',
          //   value: 'orgLevelId',
          //   list: 'orgLevelId',
          // },
          // {
          //   label: '状态',
          //   type: 'radio',
          //   value: 'isUsed',
          //   list: 'isUsed',
          // },
          //   { label: '日期', type: 'date', value: 'date' },
          //   { label: '创建时间', type: 'date', value: 'dateTime', dateType: 'datetime', clearable: true  },
          //   { label: '申请售后时间', type: 'date', value: 'range', dateType: 'daterange' }
        ],
        /** 搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /** 组件尺寸 */
        // size: 'small',
        /** 默认展示搜索条件 */
        count: 100,
        /** label/item 宽度 */
        width: {
          labelWidth: 110,
          itemWidth: 200,
        },
        /** 配置项 */
        // btnStyle: [
        //     { icon: "el-icon-refresh", text: "重置" },
        //   { icon: "el-icon-search", text: "查询", type: "primary" },
        //
        // ],
      },
      listTypeInfo: {
        orgLevelId: [
          {
            id: '',
            name: '全部',
          },
          {
            id: 101,
            name: '企业',
          },
          {
            id: 102,
            name: '单位',
          },
          {
            id: 103,
            name: '部门',
          },
        ],
        isUsed: [
          {
            id: '',
            name: '全部',
          },
          {
            id: 1,
            name: '启用',
          },
          {
            id: 0,
            name: '停用',
          },
        ],
      },
      authorityTreeData: [],
      selOrgTreeData: [],
      defaultProps: {
        label: 'shortFullName',
        isLeaf: 'isLeaf',
        children: 'childList',
      },
      dialogVisible: false,
      dialogVisibleOrganion: false,
      dialogVisibleTransfer: false,
      title: '权限新增',
      operateType: 1, // 1代表新增，0代表编辑
      formData: {
        lastNodeId: '',
        lastGradeName: '',
        orgName: '',
        orgCode: '',
        shortName: '',
        shortFullName: '',
        orglevelid: 103,
        isUsed: 1,
        ersorgCode: '',
        // extendAttr: '',
        remark: '',
        orgId: '',
        companyId: '',
      },
      rulesAuth: {
        orgName: [
          {
            required: true,
            message: '请输入组织名称',
            trigger: 'blur',
          },
          {
            validator: checkKeyword,
            trigger: 'blur',
          },
        ],
        // orgCode: [
        //   { required: true, message: '请输入机构编码', trigger: 'blur' }
        // ],
        shortName: [
          {
            required: true,
            message: '请输入机构短名称',
            trigger: 'blur',
          },
          {
            validator: checkRemark,
            trigger: 'blur',
          },
        ],
        shortFullName: [
          {
            required: true,
            message: '请输入机构简化全称',
            trigger: 'blur',
          },
          {
            validator: checkKeyword,
            trigger: 'blur',
          },
        ],
        // extendAttr: [
        //   {
        //     validator: checkKeyword,
        //     trigger: 'blur',
        //   },
        // ],
        remark: [
          {
            validator: checkKeyword,
            trigger: 'blur',
          },
        ],
        orglevelid: [
          {
            required: true,
            message: '请选择机构层级',
            trigger: 'blur',
          },
        ],
      },
      categoryId: 0,
      firstCategory: [],
      secondCategory: [],
      thirdCategory: [],
      showTree: false,
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      queryParams: {},
    };
  },
  created() {
    this.getTreeData();
    this.getInstitutionList(this.filterInfo.data);
  },
  methods: {
    filterAuthTreeNode(value, data) {
      if (!value) return true;
      return data.shortFullName.indexOf(value) !== -1;
    },
    cancelSelOrgTree() {
      this.searchVal = '';
      this.dialogVisibleOrganion = false;
    },
    confirmSelOrgTree() {
      const tempSelNode = this.$refs.selOrgTree.getCurrentNode();
      this.searchVal = '';
      this.transferFormData.nowTransferOrgId = tempSelNode.orgId;
      this.transferFormData.nowTransferOrgName = tempSelNode.shortFullName;
      this.dialogVisibleOrganion = false;
    },
    treeLoop(node) {
      for (let i = 0; i < node.length; i++) {
        if (node[i].orgId == this.transferFormData.orgId) {
          node.splice(i, 1);
          node[i].childList = [];
          break;
        } else if (node[i].childList && node[i].childList.length > 0) {
          this.treeLoop(node[i].childList);
        }
      }
    },
    confirmTransfer() {
      if (this.transferFormData.nowTransferOrgId == '') {
        this.$message({
          type: 'warning',
          message: '请选择要转移到的组织机构',
        });
        return;
      }
      const param = {
        newParentOrgId: this.transferFormData.nowTransferOrgId,
        orgId: this.transferFormData.orgId,
      };
      api
        .moveOrganzionTree(param)
        .then((res) => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '转移成功',
            });
            this.getTreeData();
            this.transferFormData.nowTransferOrgId = '';
            this.transferFormData.nowTransferOrgName = '';
            this.dialogVisibleTransfer = false;
          } else {
            console.log('1111');
            // this.$message({
            //   type: "error",
            //   message: res.message,
            // });
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '转移失败',
          });
        });
    },
    cancelTransfer() {
      this.transferFormData.nowTransferOrgId = '';
      this.transferFormData.nowTransferOrgName = '';
      this.dialogVisibleTransfer = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.shortFullName.indexOf(value) !== -1;
    },
    handleSearch(data) {
      this.productTagPage.currentPage = 1;
      const params = {
        orgName: data.orgName,
        orgLevelId: data.orgLevelId,
        isUsed: data.isUsed,
        pageSize: this.productTagPage.pageSize,
        pageStart: this.productTagPage.currentPage,
      };
      this.getInstitutionList(params);
    },
    handleReset() {},
    handleEvent() {},
    handleEnterUBM() {
      window.open(ubmUrl, '_blank');
    },
    getTreeData() {
      const params = {
        companyId: '100424',
      };
      api
        .getOrganzionTree(params)
        .then((res) => {
          if (res.code === '200') {
            this.authorityTreeData = [res.data];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    nodeAdd(node, data) {
      this.title = '新建机构';
      this.formData.lastGradeName = node.label;
      this.formData.lastNodeId = data.orgId;
      this.formData.companyId = data.companyId;
      // this.formData.authorityLevel = (Number(node.level) + 1);
      this.dialogVisible = true;
      this.operateType = 1;
    },
    resetFormData() {
      this.formData = {
        lastNodeId: '',
        lastGradeName: '',
        orgName: '',
        orgCode: '',
        shortName: '',
        shortFullName: '',
        orglevelid: 103,
        isUsed: 1,
        ersorgCode: '',
        // extendAttr: '',
        remark: '',
        orgId: '',
      };
    },
    nodeEdit(node, data) {
      if (data.parentOrgId == -1) {
        this.$message({
          type: 'error',
          message: '顶级不能修改',
        });
        return;
      }
      this.title = '修改机构';
      this.formData.lastNodeId = node.parent.key;
      this.formData.lastGradeName = node.parent.label;
      this.formData.companyId = data.companyId;
      this.getOrganTreeNodeData(data, 'nodeEdit');
      this.operateType = 0;
    },
    searchOrgTree() {
      this.$refs.selOrgTree.filter(this.searchVal);
    },
    selOrgTreeNode() {
      this.dialogVisibleOrganion = true;
    },
    nodeTransfer(node, data) {
      if (data.parentOrgId == -1) {
        this.$message({
          type: 'error',
          message: '顶级不能转移',
        });
        return;
      }
      this.selOrgTreeData = JSON.parse(JSON.stringify(this.authorityTreeData));
      this.dialogVisibleTransfer = true;
      this.transferFormData.orgName = data.shortFullName;
      this.transferFormData.orgId = data.orgId;
      this.transferFormData.lastParentOrgId = node.parent.key;
      this.transferFormData.lastParentOrgName = node.parent.label;
      this.treeLoop(this.selOrgTreeData);
    },
    nodeDelete(node, data) {
      if (data.parentOrgId == -1) {
        this.$message({
          type: 'error',
          message: '顶级不能删除',
        });
        return;
      }
      const params = {
        orgId: data.orgId,
      };
      this.$confirm('是否删除所选机构？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        api
          .deleteOrganzionTreeNodeByID(params)
          .then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '删除成功',
              });
              this.getTreeData();
            } else {
              this.$message({
                type: 'error',
                message: res.message,
              });
            }
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败',
            });
          });
      });
    },
    handleConfirm() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.operateType == 1) {
            this.addCategory();
          } else {
            this.editCategory();
          }
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.formData.lastNodeId = '';
      this.formData.lastGradeName = '';
      this.formData.orgName = '';
      this.formData.orgCode = '';
      this.formData.shortName = '';
      this.formData.shortFullName = '';
      this.formData.orglevelid = 103;
      this.formData.isUsed = '';
      this.formData.ersorgCode = '';
      // this.formData.extendAttr = '';
      this.formData.remark = '';
      this.formData.orgId = '';
      this.formData.companyId = '';
    },
    addCategory() {
      // 调用新增接口
      const params = {
        orgName: this.formData.orgName,
        orgCode: this.formData.orgCode,
        shortName: this.formData.shortName,
        shortFullName: this.formData.shortFullName,
        orglevelid: this.formData.orglevelid,
        isUsed: this.formData.isUsed,
        ersorgCode: this.formData.ersorgCode,
        // remark: this.formData.extendAttr,
        remark: this.formData.remark,
        parentOrgId: this.formData.lastNodeId,
        companyId: this.formData.companyId,
      };
      // if(!checkRemark(this.formData.extendAttr)){
      //     this.$message({
      //         type:'warning',
      //         message:'扩展属性不能超过100字符'
      //     })
      //     return
      // }
      api
        .addOrganzionTree(params)
        .then((res) => {
          if (res.code === '200') {
            this.dialogVisible = false;
            this.resetFormData();
            this.getTreeData();
            this.$message({
              type: 'success',
              message: '新增成功',
            });
          }
          // this.clearForm()
          this.getInstitutionList();
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '新增失败',
          });
        });
    },
    editCategory() {
      const params = {
        orgName: this.formData.orgName,
        orgCode: this.formData.orgCode,
        shortName: this.formData.shortName,
        shortFullName: this.formData.shortFullName,
        orglevelid: this.formData.orglevelid,
        isUsed: this.formData.isUsed,
        ersorgCode: this.formData.ersorgCode,
        remark: this.formData.remark,
        parentOrgId: this.formData.lastNodeId,
        orgId: this.formData.orgId,
        companyId: this.formData.companyId,
      };
      // if(!checkRemark(this.formData.extendAttr)){
      //     this.$message({
      //         type:'warning',
      //         message:'扩展属性不能超过100字符'
      //     })
      //     return
      // }
      api
        .updateOrganzionTree(params)
        .then((res) => {
          if (res.code === '200') {
            this.dialogVisible = false;
            this.resetFormData();
            this.getTreeData();
            this.$message({
              type: 'success',
              message: '编辑成功',
            });
          } else {
            // this.$message({
            // 	type: "error",
            // 	message: res.message,
            // });
          }
          // this.clearForm()
          this.getInstitutionList();
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '编辑失败',
          });
        });
    },
    cancelCategory() {
      this.dialogVisible = false;
      this.resetFormData();
    },
    handleNodeClick() {
      // this.getOrganTreeNodeData(data, 'ShowNodeMsg')
    },
    getOrganTreeNodeData(data, type) {
      const params = {
        orgId: data.orgId,
      };
      api
        .getOrganzionTreeNodeByID(params)
        .then((res) => {
          if (res.code === '200') {
            const tempData = res.data;
            if (type == 'nodeEdit') {
              this.dialogVisible = true;
              this.formData.orgName = tempData.orgName;
              this.formData.orgCode = tempData.orgCode;
              this.formData.shortName = tempData.shortName;
              this.formData.shortFullName = tempData.shortFullName;
              this.formData.orglevelid = tempData.orglevelid;
              this.formData.ersorgCode = tempData.ersorgCode;
              this.formData.remark = tempData.remark;
              this.formData.parentOrgId = tempData.parentOrgId;
              this.formData.orgId = tempData.orgId;
              this.formData.isUsed = tempData.isUsed;
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err,
          });
        });
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.filterInfo.data.pageSize = this.productTagPage.pageSize;
      this.getInstitutionList(this.filterInfo.data);
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.filterInfo.data.pageStart = val;
      this.getInstitutionList(this.filterInfo.data);
    },
    getInstitutionList(params) {
      api.getInstitutionList(params).then((res) => {
        this.tableData = res.data.list;
        this.productTagPage.pageTotal = res.data.total;
        if (res?.data?.total > 100) {
          this.expandAll = false;
        }
        this.showTree = true;
      });
    },
    formatStatus(val) {
      let res = '';
      switch (val) {
        case 1:
          res = '启用';
          break;
        case 0:
          res = '停用';
          break;
        default:
          res = '';
          break;
      }
      return res;
    },
    formatEnterLevel(val) {
      let res = '';
      switch (val) {
        case 101:
          res = '企业';
          break;
        case 102:
          res = '单位';
          break;
        case 103:
          res = '部门';
          break;
        default:
          res = '';
          break;
      }
      return res;
    },
    // 移动节点
    async handleDrag(node, data, direction) {
      console.log(node, data, direction);
      const { parent } = node;
      const { childNodes } = parent;
      const currentIndex = childNodes.indexOf(node);
      if (direction === 'up' && currentIndex === 0) {
        return;
      }
      if (direction === 'down' && currentIndex === childNodes.length - 1) {
        return;
      }
      const targetIndex =
        direction === 'up' ? currentIndex - 1 : currentIndex + 1;
      const childrenData =
        parent.level === 0 ? this.authorityTreeData : parent.data.childList;
      const temp = childrenData[currentIndex];
      this.$set(childrenData, currentIndex, childrenData[targetIndex]);
      this.$set(childrenData, targetIndex, temp);
      //index  转移到父节点第几位，1表示最前，-1表示最后，2表示第2位
      const sortIndex =
        direction === 'down' && targetIndex === childNodes.length - 1
          ? -1
          : targetIndex + 1;
      let res = await api.modifySortOrder({
        orgId: node.data.orgId,
        index: sortIndex,
      });
      if (res.code === '200') {
        this.showTree = false;
        this.$nextTick(() => {
          this.showTree = true;
        });
      }
    },
    // 检查是否可移动
    checkDisabled(node, data, direction) {
      const { parent } = node;
      const { childNodes } = parent;
      const currentIndex = childNodes.indexOf(node);
      if (direction === 'up' && currentIndex === 0) {
        return true;
      }
      if (direction === 'down' && currentIndex === childNodes.length - 1) {
        return true;
      }
      return false;
    },
    // 是否可拖拽
    allowDrag(node) {
      return node.data.parentOrgId !== -1;
    },
    // 是否可放置
    allowDrop(draggingNode, dropNode, type) {
      return type !== 'inner' && draggingNode.parent === dropNode.parent;
    },
    async handleNodeDrop(draggingNode, dropNode, type) {
      console.log(draggingNode, dropNode, type);
      // node-drop 事件触发时，节点已经移动到新位置，使用 dropNode.parent
      const parent = dropNode.parent;
      const { childNodes } = parent;
      const currentIndex = childNodes.findIndex(
        (node) => node.data.orgId === draggingNode.data.orgId,
      );
      console.log(currentIndex, 'currentIndex');
      console.log(childNodes, 'childNodes');

      //index  转移到父节点第几位，1表示最前，-1表示最后，2表示第2位
      let sortIndex;
      if (type === 'after' && currentIndex === childNodes.length - 1) {
        sortIndex = -1;
      } else {
        sortIndex = currentIndex + 1;
      }
      console.log(sortIndex, 'sortIndex');

      let res = await api.modifySortOrder({
        orgId: draggingNode.data.orgId,
        index: sortIndex,
      });
      if (res.code === '200') {
        this.showTree = false;
        this.$nextTick(() => {
          this.showTree = true;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-wrapper {
  height: auto;
  display: flex;
  /*flex-grow: 1;*/
}
.tooltip-wrapper {
  height: 20px;
  display: inline-block;
}

.container {
  // height: 100%;
  // display: flex;
  // border-radius: 5px;

  .content-left {
    // min-width: 350px;
    // flex: 0 0 450px;
    height: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    padding: 10px;
    margin-right: 10px;
    // min-width: 300px;
    width: 30%;

    /*overflow-y: auto;*/
    .content-title {
      width: 100%;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: rgb(242, 242, 242);
    }

    .content-btn {
      margin-top: 10px;
    }
  }

  .content-right {
    /*flex: 1;*/
    width: 70%;
    height: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;

    .content-title {
      width: 100%;
      height: 32px;
      line-height: 32px;
      background: rgb(242, 242, 242);
      padding: 0 10px;
    }

    .content-btn {
      margin-bottom: 10px;
    }
  }
}

.input-style {
  width: 330px;
}

.handle-search {
  width: 100%;
}

.el-textarea__inner {
  border-radius: none !important;
}

/* 	::v-deep  .text-area .el-textarea .el-input--small{
        border-radius:none;
    } */
</style>
